import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import withRouter from "../../HOC/withRouter";
import get from "lodash/get";
import { getImageFromUrl, getFallbackImageFromUrl } from "../../utils/imageService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import LikeButtonSmall from "../../components/svgs/LikeButtonSmall";
import LikeButtonSmallFilled from "../../components/svgs/LikeButtonSmallFilled";
import noProfile from "../../static/images/no-profile.png";
import dayjs from "dayjs";
import Modal from "react-modal";
import LikesList from "../LikesList";
import { insertTags } from "../../utils/url";
import BrandificationImageFallback from "../BrandificationImageFallback";
import MentionTextarea from "../MentionTextarea";
import "./styles.scss";
import { compose } from "react-recompose";
import { connect } from "react-redux";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import SmileEmoji from "../../components/svgs/SmileEmoji";
import EmailAt from "../svgs/EmailAt";
import { motion } from "framer-motion";
import getI18n from "../../utils/i18n";

Modal.setAppElement("#root");
class CommentsThread extends React.PureComponent {
  constructor(props) {
    super(props);
    this.commentRef = null;
    this.inputField = React.createRef();

    this.setCommentRef = element => {
      this.commentRef = element;
    };

    this.emojiPickerRef = React.createRef();
  }

  state = {
    commentToAdd: "",
    likesListVisibility: false,
    modalUsersList: [],
    emojiPickerOpen: false,
    showUserList: false,
  };

  componentDidMount() {
    document.addEventListener("mouseup", this.handleClickOutside);
    if (this.props.location.state && this.props.location.state.commentId && this.commentRef) {
      window.scrollTo(0, this.commentRef.offsetTop);
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mouseup", this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.emojiPickerRef.current && !this.emojiPickerRef.current.contains(event.target)) {
      if (!event.target.closest(".smiley-icon")) {
        this.setState({ emojiPickerOpen: false });
      }
    }
  };

  insertAtSymbol = () => {
    this.setState(prevState => ({
      commentToAdd: prevState.commentToAdd + "@",
    }));
    this.inputField.current.focus();
  };

  onCommentChange = e => {
    this.setState({
      commentToAdd: e.target.value,
    });
  };

  addNewComment = () => {
    if (this.state.editModeId) {
      this.props.onCommentEdit(this.state.commentToAdd, this.state.editModeId);
    } else {
      this.props.onCommentAdd(this.state.commentToAdd);
    }

    this.setState({
      commentToAdd: "",
      editModeId: "",
    });
  };

  viewProfile = user => {
    this.props.navigate(`/view-profile/${user._id}`);
  };

  getCommentDeleteVisibility = comment => {
    if (["admin", "superadmin"].indexOf(this.props.user.role) > -1) {
      return true;
    }
    if (["user"].indexOf(this.props.user.role) > -1) {
      return comment?.user?._id === this.props?.user?._id;
    }
    return false;
  };

  showLikesModal = comment => {
    const modalUsersList = comment.likes.map(l => l.userId);
    this.setState({
      likesListVisibility: true,
      modalUsersList,
    });
  };

  hideLikesModal = () => {
    this.setState({
      likesListVisibility: false,
      modalUsersList: [],
    });
  };

  setEditMode = comment => {
    this.setState({
      commentToAdd: comment.comment,
      editModeId: comment._id,
    });
    this.inputRef.scrollIntoView();
  };

  handleEmojiSelect = emoji => {
    this.setState({
      commentToAdd: this.state.commentToAdd + emoji.native,
    });
    this.inputField.current.focus();
  };

  displayComments = (comment, i) => {
    const { t, client } = this.props;
    let commentToScroll = this.props.location.state && this.props.location.state.commentId;
    return (
      <div
        ref={commentToScroll && commentToScroll === comment._id && this.setCommentRef}
        key={i}
        className="comment-wrapper"
      >
        <div className="comment-body">
          <div className="comment-header">
            <BrandificationImageFallback
              onClick={() => this.viewProfile(comment.user)}
              src={getImageFromUrl(get(comment, "user.photoURL"))}
              fallbackImage={getFallbackImageFromUrl(get(comment, "user.photoURL"), noProfile)}
              className="user-logo-div"
            />
            <div>
              <div className="user-name" onClick={() => this.viewProfile(comment.user)}>
                {get(comment, "user.name")}
              </div>
              <div className="comment-date">{dayjs(comment.createdAt).format("DD.MM.YYYY - HH:mm")}</div>
            </div>
            {this.getCommentDeleteVisibility(comment) && (
              <div className="remove-comment">
                <div className="dropdown">
                  <FontAwesomeIcon
                    icon={faEllipsisV}
                    className="menu-icon dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    id="dropdownMenu2"
                  />
                  <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                    {this.props.user && comment.user && this.props.user._id === comment.user._id && (
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={() => {
                          this.setEditMode(comment);
                        }}
                      >
                        {t("touchpoint.EditComment")}
                      </button>
                    )}
                    <button
                      className="dropdown-item"
                      type="button"
                      onClick={() => {
                        this.props.onDeleteComment(comment);
                      }}
                    >
                      {t("touchpoint.DeleteComment")}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="comment-text">
            <pre
              className="display-comment-textarea"
              dangerouslySetInnerHTML={{
                __html: insertTags(comment.comment),
              }}
            ></pre>
          </div>
          <div className="comment-like">
            <span
              className="like-button"
              onClick={() => {
                this.props.onLikeComment(comment);
              }}
            >
              {comment.wasLiked ? (
                <LikeButtonSmallFilled color={client.altColor} />
              ) : (
                <LikeButtonSmall color={client.altColor} />
              )}
            </span>
            {comment.likes && comment.likes.length > 0 && (
              <span className="likes-total" onClick={() => this.showLikesModal(comment)}>
                <span>-</span>
                {comment.likes.length}{" "}
                {comment.likes.length > 1
                  ? this.props.t("touchpoint.LikesTotal")
                  : this.props.t("touchpoint.LikeTotal")}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { t, client, isPdfPage } = this.props;
    return (
      <div className="comments-thread">
        <div className="component-title">{t("touchpoint.Comment")}</div>
        <div className="comment-block">
          {this.props.comments.map(this.displayComments)}
          <Modal
            isOpen={this.state.likesListVisibility}
            onRequestClose={this.hideLikesModal}
            className="brandification-modal-base like-modal-base"
            contentLabel="Likes Modal"
          >
            <LikesList
              users={this.state.modalUsersList}
              viewProfile={this.viewProfile}
              onCancel={this.hideLikesModal}
            />
          </Modal>
        </div>
        <div className="shareCommentContainer">
          <div className={this.props.comments.length > 0 ? "comment-wrapper" : "comment-wrapper no-comments"}>
            <div className="comment-body add-comment-body">
              <div className="comment-header">
                <BrandificationImageFallback
                  onClick={() => this.viewProfile(this.props.user)}
                  src={getImageFromUrl(this.props.user.photoURL)}
                  fallbackImage={getFallbackImageFromUrl(this.props.user.photoURL, noProfile)}
                  className="user-logo-div"
                />
                <div className="user-name">{this.props.user.name}</div>

                {!isPdfPage && (
                  // Emoji-Picker Toggle
                  <span
                    className="smiley-icon"
                    onClick={() => {
                      this.setState(prevState => ({
                        emojiPickerOpen: !prevState.emojiPickerOpen,
                      }));
                    }}
                  >
                    <SmileEmoji size={1} color={client.altColor} />
                  </span>
                )}

                {!isPdfPage && (
                  // EmailAt Symbol
                  <span className="email-icon" onClick={this.insertAtSymbol}>
                    <EmailAt size={1} color={client.altColor} />
                  </span>
                )}

                {/* Emoji-Picker */}
                {this.state.emojiPickerOpen && (
                  <motion.div
                    className="emoji-picker open"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    ref={this.emojiPickerRef}
                  >
                    <Picker
                      data={data}
                      onEmojiSelect={this.handleEmojiSelect}
                      theme="light"
                      i18n={getI18n(client.lang)}
                    />
                  </motion.div>
                )}
              </div>

              <div className="comment-input">
                <MentionTextarea
                  onChange={this.onCommentChange}
                  value={this.state.commentToAdd}
                  placeholder={this.props.t("touchpoint.WriteComment") + " ..."}
                  className="add-comment-textarea"
                  maxLength="2000"
                  inputRef={this.inputField}
                />
                {this.state.commentToAdd && (
                  <FontAwesomeIcon icon={faPaperPlane} className="share-comment" onClick={this.addNewComment} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CommentsThread.propTypes = {
  comments: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  onCommentAdd: PropTypes.func.isRequired,
  onDeleteComment: PropTypes.func.isRequired,
};

CommentsThread.defaultProps = {
  comments: [],
  user: { photoURL: "123" },
  onCommentAdd: () => {},
  onDeleteComment: () => {},
  onCommentEdit: () => {},
};

const mapStateToProps = state => ({
  client: state.client.client,
  users: state.client.users,
});

export default compose(withRouter, connect(mapStateToProps, null))(withTranslation()(CommentsThread));
